import * as ActionTypes from './actionTypes';

export const loadingExcel = (loading) => ({
  'type': ActionTypes.LOADING_EXCEL_DATA,
  'payload': loading,
});
